import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import 'antd/dist/antd.min.css';

import Router from "./router";
import { LanguageProvider } from "./contexts/LanguageContext";

const App = () => (
  <BrowserRouter>
    <LanguageProvider>
      <Router />
    </LanguageProvider>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById("root"));
